import { V3toVector3 as s } from "../index9.js";
function i(e, n = 0.01) {
  const t = [];
  for (let o = 0; o < e.length - 1; o++) {
    const r = s(e[o]), c = s(e[o + 1]);
    r.distanceToSquared(c) > n * n && t.push(r.toArray());
  }
  return t.push(t[0]), t;
}
export {
  i as collapsePolygonPoints
};
//# sourceMappingURL=index4.js.map
